module.exports = __webpack_public_path__ + "media/images/request-2-604aab4fbdcca437cf8366ae078c2741.png";